import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@shared/guards/auth/auth.guard';
import { RolesGuard } from '@shared/guards/roles/roles.guard';
import { ActionsButtonComponent } from '@shared/components/actions-button/actions-button.component';
import { MaterialModule } from '@shared/material.module';
import { ImageLoaderComponent } from '@shared/components/image-loader/image-loader.component';
import { ModalAlertComponent } from '@shared/components/modal-alert/modal-alert.component';
import { FilterToTime } from '@shared/pipes/to-time.pipe';
import { MapsService } from '@shared/services/map.service';
import { BranchService } from '@shared/services/branch.service';
import { DayScheduleComponent } from '@shared/components/day-schedule/day-schedule.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ScheduleBranchService } from '@shared/services/shedule-branch.service';
import { OrdersAssignmentService } from '@shared/services/order-assigment.service';
import { AssingModalComponent } from '@app/shared/components/assing-modal/assing-modal.component';
import { ModalAlertService } from '@shared/services/modal-alert.service';
import { FilteringByBranchComponent } from '@shared/components/filtering-by-branch/filtering-by-branch.component';
import { DeliveryComponent } from '@shared/components/delivery/delivery.component';
import { FirebaseService } from '@shared/services/firebase.service';
import { DeliveryService } from '@shared/services/delivery.service';
import { TrakingComponent } from '@shared/components/traking/traking.component';
import { RatingComponent } from '@shared/components/rating/rating.component';
import { PlacesModalComponent } from '@shared/components/places-modal/places-modal.component';
import { NeighborhoodService } from '@shared/services/neighborhood.service';
import { ChangePasswordModalComponent } from './components/change-password-modal/change-password-modal.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ChangePassWordService } from './services/change-password.service';
import { OffersService } from './services/offers.service';

const imports = [
  CommonModule,
  HttpClientModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  MaterialModule
];

const declarations = [
  RatingComponent,
  ActionsButtonComponent,
  ImageLoaderComponent,
  ModalAlertComponent,
  FilterToTime,
  DayScheduleComponent,
  AssingModalComponent,
  FilteringByBranchComponent,
  DeliveryComponent,
  TrakingComponent,
  PlacesModalComponent,
  ChangePasswordComponent,
  ChangePasswordModalComponent
];

const providers = [
  AuthGuard,
  RolesGuard,
  MapsService,
  BranchService,
  ScheduleBranchService,
  OffersService,
  OrdersAssignmentService,
  ModalAlertService,
  FirebaseService,
  DeliveryService,
  NeighborhoodService,
  ChangePassWordService
];

const entryComponents = [
  ModalAlertComponent,
  DayScheduleComponent,
  AssingModalComponent,
  TrakingComponent,
  PlacesModalComponent,
  ChangePasswordModalComponent
];

@NgModule({
  imports: [...imports, NgxMaterialTimepickerModule.forRoot()],
  declarations: declarations,
  providers: providers,
  entryComponents: entryComponents,
  exports: [...imports, ...declarations]
})
export class SharedModule { }
